import React from "react";
import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";

const Generator_zmj20b = () => {
  return (
    <div>
      <Navbar />
      <div>
        <h1 className="mt-5 pt-5">This Is Oxygen Generator 20ltm</h1>
      </div>
      <Footer />
    </div>
  );
};

export default Generator_zmj20b;
